// extracted by mini-css-extract-plugin
module.exports = {"title":"LotTitle_title__NhQ3V","canceledLabel":"LotTitle_canceledLabel__jP9U6"};